import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import TextField from '../TextField';
import FilterLabel from './FilterLabel';
import { filterPropTypes } from '../../../../utility/prop_types/CriteriaPropType';
import SelectTextField from '../SelectTextField';
import { MenuItem } from '@material-ui/core';

const propTypes = {
    ...filterPropTypes,
    max: PropTypes.number
};

const defaultProps = {
    max: undefined
};

function AreaFilter ({ tree, field, onChange, onClear, max }) {
    const classes = useStyles();
    const { properties } = tree;

    // If values are somehow passed through with operator but no values
    // Or values passed through with no operator then you get weird behaviour
    function getOperatorValue (min, max) {
        if ((Boolean(min) || min === 0) && (Boolean(max) || max === 0)) {
            return 'between';
        } else if ((Boolean(min) || min === 0) && !(Boolean(max) || max === 0)) {
            return 'greater';
        } else if (!(Boolean(min) || min === 0) && (Boolean(max) || max === 0)) {
            return 'less';
        } else {
            return '';
        }
    }

    // The operator is determined from the values so given a unit and operator can determine if valid
    // If everything has been cleared then that is also valid as the filter will not apply
    function isValid(unit, operator) {
        return (
            (unit != null && unit !== '' && operator != null && operator !== '') ||
            ((unit == null || unit === '') && (operator == null || operator === ''))
        );
    }

    function handleMinChange (event) {
        const operator = getOperatorValue(event.target.value, tree.properties.value1);
        const valid = isValid(tree.properties.unit, operator);
        if (valid && operator === '') {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            newTree.properties = {
                ...newTree.properties,
                value0: (event.target.type === 'number' && event.target.value !== '') ? Number(event.target.value) : event.target.value,
                operator: operator,
                valid: valid
            };
            onChange(newTree);
        }
    }

    function handleMaxChange (event) {
        const operator = getOperatorValue(tree.properties.value0, event.target.value);
        const valid = isValid(tree.properties.unit, operator);
        if (valid && operator === '') {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            newTree.properties = {
                ...newTree.properties,
                value1: (event.target.type === 'number' && event.target.value !== '') ? Number(event.target.value) : event.target.value,
                operator: operator,
                valid: valid
            };
            onChange(newTree);
        }
    }

    function handeUnitChange (event) {
        const operator = getOperatorValue(tree.properties.value0, tree.properties.value1);
        const valid = isValid(event.target.value, tree.properties.operator);
        if (valid && event.target.value === '') {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            newTree.properties = {
                ...newTree.properties,
                unit: event.target.value,
                operator: operator,
                valid: valid
            };
            onChange(newTree);
        }
    }

    const valid = isValid();
    // TODO - can reuse code from number filter but for the moment copy paste
    return (
        <div className={classes.root}>
            <FilterLabel field={field} />
            <TextField
                type="number"
                name="value0"
                onChange={handleMinChange}
                placeholder={field.placeholder || 'No Min'}
                value={properties.value0 != null ? properties.value0 : ''}
                error={
                    (properties.operator === 'between' && properties.value1 < properties.value0) ||
                    (properties.unit != null && properties.unit !== '' && (properties.operator == null || properties.operator === ''))
                }
                inputProps={{ min: 0, max: max }}
                // May need to allow input adornments in future
                // InputProps={{
                //     startAdornment: <InputAdornment position="start">£</InputAdornment>,
                // }}
            />
            <TextField
                type="number"
                name="value1"
                onChange={handleMaxChange}
                placeholder={field.placeholder || 'No Max'}
                value={properties.value1 != null ? properties.value1 : ''}
                error={
                    (properties.operator === 'between' && properties.value1 < properties.value0) ||
                    (properties.unit != null && properties.unit !== '' && (properties.operator == null || properties.operator === ''))
                }
                inputProps={{ min: 0, max: max }}
            />
            <SelectTextField
                classes={{ root: classes.unit }}
                name="unit"
                onChange={handeUnitChange}
                value={properties.unit != null ? properties.unit : ''}
                error={((properties.unit == null || properties.unit === '') && properties.operator != null && properties.operator !== '')}
                placeholder="Unit"
            >
                {
                    (properties.unit != null && properties.unit != '') &&
                    <MenuItem value=""><i>{'clear'}</i></MenuItem>
                }
                <MenuItem value="ac">{'ac'}</MenuItem>
                <MenuItem value="ha">{'ha'}</MenuItem>
                <MenuItem value="m2">{'m²'}</MenuItem>
                <MenuItem value="sqft">{'sqft'}</MenuItem>
            </SelectTextField>           
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        '&> *:not(:last-child)': {
            marginRight: 10
        },
        '&> div': {
            flexGrow: 1
        }
    },
    unit: {
        minWidth: 80
    }
}));

AreaFilter.propTypes = propTypes;
AreaFilter.defaultProps = defaultProps;

export default AreaFilter;